import { useFormDataQuery } from '@/api/getters';
import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { Input } from '@/components/ui/Input';
import { OWNER_ACCOUNT_IS_OWNER_NAME } from '@/features/v2/summaryForms/components/CheckboxAccountIsOwner';
import { OWNER_FIRST_NAME_NAME } from '@/features/v2/summaryForms/components/InputFirstName';
import { validateLastName } from '@/features/v2/summaryForms/Validate';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const OWNER_LAST_NAME_NAME = 'owner.last_name';

const InputLastName = ({
  name = OWNER_LAST_NAME_NAME,
  focused,
  setFocused,
  autoCompleteOff = false,
}: {
  name: string;
  focused: string;
  setFocused: (value: string) => void;
  autoCompleteOff?: boolean;
}) => {
  const { i18n } = useLingui();
  const { watch, trigger } = useFormContext();
  const { data } = useFormDataQuery();

  const isAccountOwner =
    !!watch(OWNER_ACCOUNT_IS_OWNER_NAME) && name === OWNER_FIRST_NAME_NAME;

  return (
    <FormField
      name={name}
      defaultValue={isAccountOwner ? data?.user?.first_name : ''}
      rules={{
        validate: (value: string) => validateLastName(value),
      }}
      render={({ field, fieldState }) => {
        const { onChange, onBlur, ...restField } = field;
        return (
          <FormItem className="col-span-4 md:col-span-3">
            <FormControl>
              <Input
                autoComplete={autoCompleteOff ? 'none' : 'family-name'}
                label={i18n.t('Nazwisko')}
                error={fieldState.error?.message}
                success={
                  focused !== field.name && !fieldState.error && field.value
                }
                onChange={(e) => {
                  onChange(e);
                  if (fieldState.error) {
                    trigger(field.name);
                  }
                }}
                onBlur={() => {
                  setFocused('');
                  onBlur();
                }}
                onFocus={() => setFocused(field.name)}
                {...restField}
              />
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
};

export default InputLastName;
